
import { escapeHtml, stripHtmlTags } from "./htmlUtils";

export async function generateLetterPDF(content: string, deliveryDate: string): Promise<void> {
  // Create a new window for PDF generation
  const printWindow = window.open('', '_blank');
  
  if (!printWindow) {
    throw new Error('Não foi possível abrir a janela de impressão');
  }

  const cleanContent = escapeHtml(stripHtmlTags(content));
  const safeDeliveryDate = escapeHtml(deliveryDate);
  
  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Carta do Futuro - ${safeDeliveryDate}</title>
      <style>
        @page {
          margin: 2cm;
          size: A4;
        }
        
        body {
          font-family: 'Times New Roman', serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background: white;
        }
        
        .container {
          max-width: 100%;
          margin: 0 auto;
          padding: 20px;
          min-height: calc(100vh - 100px);
          position: relative;
        }
        
        .header {
          text-align: center;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 2px solid #10b981;
        }
        
        .header h1 {
          color: #10b981;
          font-size: 28px;
          margin: 0;
          font-weight: bold;
        }
        
        .delivery-date {
          font-size: 16px;
          color: #666;
          margin-top: 10px;
          font-style: italic;
        }
        
        .content {
          font-size: 14px;
          line-height: 1.8;
          text-align: justify;
          margin-bottom: 60px;
          white-space: pre-wrap;
        }
        
        .footer {
          position: fixed;
          bottom: 1cm;
          left: 2cm;
          right: 2cm;
          text-align: center;
          font-size: 12px;
          color: #666;
          border-top: 1px solid #ddd;
          padding-top: 10px;
        }
        
        .footer a {
          color: #10b981;
          text-decoration: none;
        }
        
        @media print {
          body { print-color-adjust: exact; }
          .container { page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>CARTA DO FUTURO</h1>
          <div class="delivery-date">Entregue em: ${safeDeliveryDate}</div>
        </div>
        
        <div class="content">
          ${cleanContent}
        </div>
      </div>
      
      <div class="footer">
        <p>Gerado por <a href="${window.location.origin}">Carta do Futuro</a> - Sua mensagem através do tempo</p>
      </div>
    </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();
  
  // Wait for content to load then print
  printWindow.onload = function() {
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };
}
